import Box from '@mui/material/Box'
import InfiniteMasonry from '@shared/components/InfiniteMasonry'

export default function ImageGallary({
    images,
    onImageClick
}) {
    return (
        <InfiniteMasonry
            items={images}
            renderItem={(image, isLast, lastRef) => {
                const index = images.findIndex(i => i.id === image.id)
                return (
                    <Box
                        key={image.id}
                        ref={isLast ? lastRef : null}
                        onClick={() => onImageClick(index)}
                        sx={{
                            position: 'relative',
                            maxHeight: 200,
                            overflow: 'hidden',
                            cursor: 'pointer',
                        }}
                    >
                        <img
                            src={image.url || image.image}
                            style={{
                                width: '100%',
                                display: 'block'
                            }}
                        />
                    </Box>
                )
            }}
        />
    )
}